import { Capacitor } from "@capacitor/core";
import { App } from "@capacitor/app";
import { StatusBar, Style } from "@capacitor/status-bar";
import { SplashScreen } from "@capacitor/splash-screen";
import { Keyboard, KeyboardResize } from "@capacitor/keyboard";
import router from "@/router";

export async function initNativeUi(): Promise<void> {
  if (!Capacitor.isNativePlatform()) return;

  await StatusBar.setOverlaysWebView({ overlay: false }).catch(() => undefined);
  await StatusBar.setStyle({ style: Style.Light }).catch(() => undefined);
  if (Capacitor.getPlatform() === "android") {
    await StatusBar.setBackgroundColor({ color: "#889D90" }).catch(() => undefined);
  }

  await App.addListener("backButton", ({ canGoBack }) => {
    if (router.currentRoute.value.path === "/" || !canGoBack) {
      void App.exitApp();
    } else {
      router.back();
    }
  }).catch(() => undefined);

  await Keyboard.setResizeMode({ mode: KeyboardResize.Native }).catch(() => undefined);
  await SplashScreen.hide().catch(() => undefined);
}
